import type { AreaCatalog } from '../area';
import type { accessErrors as en } from '../en/accessErrors';

export const accessErrors = {
  'accessErrors.verb.act': 'handeln',
  'accessErrors.verb.grant': 'Zugriff freigeben',
  'accessErrors.verb.revoke': 'Zugriff widerrufen',
  'accessErrors.verb.addToAgenda': 'auf die Tagesordnung einer Besprechung setzen',
  'accessErrors.verb.declineCeremonyDecision': 'eine Entscheidung der Besprechung ablehnen',
  'accessErrors.verb.joinFlow': 'in einen Ablauf aufnehmen',
  'accessErrors.verb.removeFromFlow': 'aus einem Ablauf herausnehmen',
  'accessErrors.verb.advance': 'vorrücken',
  'accessErrors.verb.moveInFlow': 'im Ablauf verschieben',
  'accessErrors.verb.holdInFlow': 'im Ablauf anhalten',
  'accessErrors.verb.waiveCondition': 'eine Bedingung erlassen',
  'accessErrors.verb.addConditionWork': 'Aufgaben zu einer Bedingung hinzufügen',
  'accessErrors.verb.gateOn': 'zur Bedingung machen',
  'accessErrors.verb.attach': 'eine Datei hinzufügen',
  'accessErrors.verb.detach': 'eine Datei entfernen',
  'accessErrors.verb.editModuleData': 'Daten eines Abschnitts bearbeiten',
  'accessErrors.verb.addOrRemoveModule': 'Abschnitte hinzufügen oder entfernen',
  'accessErrors.verb.stageChangeOn': 'eine Änderung vormerken',
  'accessErrors.verb.askAbout': 'nachfragen',
  'accessErrors.verb.declineChange': 'eine Änderung ablehnen',
  'accessErrors.verb.promoteDependency': 'eine Abhängigkeit hochstufen',
  'accessErrors.verb.reorderChildren': 'Unteraufgaben umsortieren',
  'accessErrors.verb.editChecklist': 'die Liste bearbeiten',
  'accessErrors.verb.reverseChanges': 'Änderungen zurücknehmen',
  'accessErrors.verb.noteStatement': 'eine Notiz zu einer Aussage schreiben',
  'accessErrors.verb.tag': 'Tags setzen',
  'accessErrors.verb.untag': 'Tags entfernen',
  'accessErrors.verb.clearHealth': 'den Zustand aufheben',
  'accessErrors.verb.qualifyStatement': 'eine Aussage einstufen',
  'accessErrors.verb.clearQualification': 'eine Einstufung aufheben',
  'accessErrors.verb.pin': 'anheften',
  'accessErrors.verb.invite': 'einladen',
  'accessErrors.verb.revokeInvite': 'eine Einladung widerrufen',
  'accessErrors.verb.offerSeat': 'Verantwortung oder Zuständigkeit anbieten',
  'accessErrors.verb.requestAccess': 'Zugriff anfragen',
  'accessErrors.verb.conveneCeremony': 'eine Besprechung einberufen',
  'accessErrors.verb.elevate': 'den Eingriffsmodus einschalten',
  'accessErrors.verb.createLens': 'eine Ansicht erstellen',
  'accessErrors.verb.saveWorkLens': 'die eigene Seite „Aufgaben“ speichern',
  'accessErrors.verb.restoreWorkLens': 'die eigene Seite „Aufgaben“ wiederherstellen',
  'accessErrors.verb.adoptWorkLens': 'eine Ansicht in „Aufgaben“ übernehmen',
  'accessErrors.verb.forkLens': 'eine Ansicht abzweigen',
  'accessErrors.verb.createGroup': 'eine Gruppe erstellen',
  'accessErrors.verb.authorProposal': 'einen Vorschlag verfassen',
  'accessErrors.verb.stageChange': 'eine Änderung vormerken',
  'accessErrors.verb.createBoard': 'ein Board erstellen',
  'accessErrors.verb.shareView': 'ein Board teilen',
  'accessErrors.verb.createWork': 'hier Aufgaben erstellen',
  'accessErrors.verb.updateLens': 'diese Ansicht ändern',
  'accessErrors.verb.sortLens': 'diese Ansicht sortieren',
  'accessErrors.verb.rename': 'umbenennen',
  'accessErrors.verb.archive': 'archivieren',
  'accessErrors.verb.restore': 'wiederherstellen',
  'accessErrors.verb.configureIt': 'sie einrichten',
  'accessErrors.verb.configureView': 'dieses Board einrichten',
  'accessErrors.verb.configureBoard': 'ein Board einrichten',
  'accessErrors.verb.attachLens': 'eine Ansicht anhängen',
  'accessErrors.verb.changeAudience': 'ihren Personenkreis ändern',
  'accessErrors.verb.nameSuccessor': 'benennen',
  'accessErrors.verb.promoteSuccessor': 'ernennen',

  'accessErrors.item.noAccess': 'Ohne Zugriff auf die Aufgabe kannst du hier nicht {verb}.',
  'accessErrors.item.seeOnly': 'Du kannst diese Aufgabe sehen, aber hier nicht {verb}.',
  'accessErrors.ref.malformed': 'Ungültige Referenz: {ref}',
  'accessErrors.ref.notHolder': 'Zugriff kann nur eine Person oder eine Gruppe haben.',

  'accessErrors.grant.roleAlreadyGranted': 'Diese Rolle ist schon freigegeben.',
  'accessErrors.grant.seated':
    'Diese Person trägt hier gerade Verantwortung oder Zuständigkeit. Vergib sie zuerst neu, dann widerrufe den Zugriff.',
  'accessErrors.grant.noSuchGrant': 'Diese Freigabe gibt es nicht.',
  'accessErrors.grant.alreadyHeld': 'Du hast hier schon eine Freigabe.',
  'accessErrors.grant.requestPending': 'Die Anfrage ist schon offen.',

  'accessErrors.group.notInOrg': 'Gruppe in dieser Organisation nicht gefunden.',
  'accessErrors.group.lastOwner':
    'Eine Gruppe braucht mindestens eine verwaltende Person. Du musst zuerst eine Nachfolge {verb}.',
  'accessErrors.group.ownerDescribesOnly': 'Nur Verwaltende der Gruppe können sie beschreiben.',
  'accessErrors.group.alreadyDescription': 'Die Beschreibung ist schon so.',
  'accessErrors.member.already': 'Schon Mitglied.',
  'accessErrors.member.notMember': 'Kein Mitglied.',
  'accessErrors.member.alreadyRole': 'Die Rolle ist schon so.',
  'accessErrors.member.ownerAddsOnly': 'Nur Verwaltende der Gruppe können Mitglieder hinzufügen.',
  'accessErrors.member.ownerRemovesOnly': 'Nur Verwaltende der Gruppe können Mitglieder entfernen.',
  'accessErrors.member.ownerSetsRoleOnly':
    'Nur Verwaltende der Gruppe können die Rolle eines Mitglieds ändern.',
  'accessErrors.member.nestingIsTwoSided':
    'Eine Gruppe unterzuordnen braucht beide Seiten; nutze proposeNesting.',
  'accessErrors.member.askThrottled':
    'Du hast zuletzt zu viele Personen gefragt, ob sie beitreten. Warte bitte eine Weile.',
  'accessErrors.invitation.notFound': 'Diese Einladung gibt es nicht.',
  'accessErrors.invitation.noOwner': 'Diese Gruppe hat keine Verwaltenden mehr.',
  'accessErrors.nesting.self': 'Eine Gruppe kann sich nicht sich selbst unterordnen.',
  'accessErrors.nesting.ownerProposesOnly':
    'Nur Verwaltende einer der beiden Gruppen können eine Unterordnung vorschlagen.',
  'accessErrors.nesting.ownerAcceptsOnly':
    'Nur Verwaltende einer der beiden Gruppen können annehmen.',
  'accessErrors.nesting.ownerSeversOnly':
    'Nur Verwaltende einer der beiden Gruppen können die Unterordnung lösen.',
  'accessErrors.nesting.alreadyNested': 'Schon untergeordnet oder vorgeschlagen.',
  'accessErrors.nesting.notPending': 'Die Unterordnung ist nicht offen.',
  'accessErrors.nesting.otherSideAccepts':
    'Eine Unterordnung, die von dieser Seite vorgeschlagen wurde, nimmt die andere Gruppe an.',

  'accessErrors.org.oneCommons':
    'Es gibt schon einen gemeinsamen Bereich, und es gibt genau einen.',
  'accessErrors.org.operatorSetsKind':
    'Nur Betreibende können die Art einer Organisation festlegen.',
  'accessErrors.org.alreadyCommons': 'Schon der gemeinsame Bereich.',
  'accessErrors.org.alreadyJurisdiction': 'Schon ein Hoheitsbereich.',

  'accessErrors.view.rootNotFound': 'Ausgangsaufgabe nicht gefunden.',
  'accessErrors.view.flowNotFound': 'Diesen Ablauf gibt es nicht.',
  'accessErrors.view.flowOtherOrg': 'Ein Board verknüpft nur Abläufe seiner eigenen Organisation.',
  'accessErrors.view.anchoredFlow':
    'Ein Ablauf, der an einer Aufgabe hängt, gehört nur zu ihrem eigenen Board.',
  'accessErrors.view.flowMemberLinks':
    'Um einen Ablauf zu verknüpfen, brauchst du Zugriff als Mitglied.',
  'accessErrors.view.flowInactive': 'Dieser Ablauf ist nicht mehr aktiv.',
  'accessErrors.view.lanesOneSource':
    'Ein Board bildet Spalten aus seinem Ablauf oder aus eigenen Spalten, nicht aus beidem.',
  'accessErrors.view.ownerOnly': 'Nur Verwaltende können {verb}.',
  'accessErrors.view.ownerDeletesOnly': 'Nur Verwaltende des Boards können es löschen.',
  'accessErrors.view.memberChangesOnly': 'Nur Mitglieder dieses Boards können es ändern.',
  'accessErrors.view.memberSharesOnly':
    'Nur Mitglieder dieses Boards können seine Aufgaben teilen.',
  'accessErrors.view.memberPinsOnly': 'Nur Mitglieder dieses Boards können hier Aufgaben anheften.',
  'accessErrors.view.memberUnpinsOnly': 'Nur Mitglieder dieses Boards können hier Aufgaben lösen.',
  'accessErrors.view.lensNotDeleted':
    'Eine Ansicht wird archiviert (sie bleibt lesbar), nie gelöscht.',
  'accessErrors.view.shareNeedsAudience':
    'Nenne mindestens eine Person oder Gruppe, mit der du die Aufgaben teilst.',
  'accessErrors.view.pinNeedsOwner':
    'Wer an ein geteiltes Board anheftet, teilt die Aufgabe mit seinem Personenkreis. Dafür musst du die Aufgabe verwalten oder für sie verantwortlich sein.',
  'accessErrors.view.workLensPersonal':
    'Deine Seite „Aufgaben“ ist persönlich. Speichere sie als Ansicht, um zu teilen, wie du auf die Aufgaben schaust.',
  'accessErrors.view.lensNotFound': 'Diese Ansicht gibt es nicht.',
  'accessErrors.view.lensOtherOrg': 'Ein Board hängt nur Ansichten seiner eigenen Organisation an.',
  'accessErrors.view.lensRetired':
    'Eine archivierte Ansicht kann nicht angehängt werden (zweige sie ab, um die Einstellungen zu behalten).',
  'accessErrors.view.noLens': 'Es ist keine Ansicht angehängt.',
  'accessErrors.view.noManualLanes': 'Dieses Board nutzt keine eigenen Spalten.',
  'accessErrors.view.archived': 'Dieses Board ist archiviert. Stelle es zuerst wieder her.',
  'accessErrors.view.alreadyArchived': 'Das ist schon archiviert.',
  'accessErrors.view.notArchived': 'Das ist nicht archiviert.',
  'accessErrors.view.nameUnchanged': 'Das ist schon der Name.',
  'accessErrors.view.ownerNeedsHolder':
    'Verwaltende müssen dir bekannt sein: eine Person mit aktivem Konto oder eine Gruppe dieser Organisation.',
  'accessErrors.view.lastOwnerStays':
    'Sonst verwaltet es niemand. Gib zuerst jemand anderem die Rolle Verwaltende, oder archiviere es.',
  'accessErrors.view.leaveThroughGroup':
    'Du bist über eine Gruppe dabei, darum gibt es nichts, das du allein verlassen kannst.',
  'accessErrors.view.rootNeedsMember':
    'Nur wer an der Aufgabe arbeiten darf, kann sie zur Ausgangsaufgabe eines Boards machen.',
  'accessErrors.view.memberCreatesOnly':
    'Nur Mitglieder dieses Boards können hier Aufgaben hinzufügen.',
  'accessErrors.lane.noLabel': 'Eine Spalte braucht eine Bezeichnung.',
  'accessErrors.lane.duplicate': 'Die Spalte „{lane}“ gibt es doppelt.',
  'accessErrors.lane.notFound': 'Diese Spalte gibt es auf diesem Board nicht.',

  'accessErrors.lens.notFound': 'Ansicht nicht gefunden.',
  'accessErrors.lens.noStandard':
    'Diese Organisation hat keinen Standard für „Aufgaben“, aus dem du wiederherstellen kannst.',
  'accessErrors.lens.matchesStandard': 'Deine Aufgaben entsprechen schon dem Standard.',
  'accessErrors.lens.isYourWork': 'Diese Ansicht ist schon deine Seite „Aufgaben“.',
  'accessErrors.lens.matchesWork': 'Deine Aufgaben entsprechen schon dieser Ansicht.',
  'accessErrors.lens.workLensStays':
    'Deine Seite „Aufgaben“ gehört zu dir. Sie behält ihren Namen und lässt sich nicht archivieren.',
  'accessErrors.lens.archived': 'Diese Ansicht ist archiviert. Stelle sie zuerst wieder her.',
  'accessErrors.lens.unknownRail': 'Unbekannte Darstellung.',
  'accessErrors.lens.badSlice': 'Dieser Teil der Liste lässt sich nicht lesen.',

  'accessErrors.tag.notFound': 'Den Zustand „{key}“ gibt es nicht.',
  'accessErrors.tag.derived': 'Diesen Zustand setzt das System, er wird nicht angegeben.',
  'accessErrors.tag.citedItemNotFound': 'Die zitierte Aufgabe wurde nicht gefunden.',
  'accessErrors.tag.citedDeclarationNotFound': 'Die zitierte Angabe wurde nicht gefunden.',
  'accessErrors.tag.declarationNotFound': 'Angabe nicht gefunden.',

  'accessErrors.criteria.notObject': 'Ein Kriterium muss ein Objekt sein.',
  'accessErrors.criteria.tenderedBoolean':
    'Ein Kriterium zu Fertig oder in Review braucht den Wert true oder false.',
  'accessErrors.criteria.cancelledBoolean':
    'Ein Abgebrochen-Kriterium braucht den Wert true oder false.',
  'accessErrors.criteria.doneBoolean': 'Ein Fertig-Kriterium braucht den Wert true oder false.',
  'accessErrors.criteria.judgmentOneOf':
    'Ein Kriterium zur Bewertung braucht eine Liste von Werten, jeder eins von {values}.',
  'accessErrors.criteria.seatRole':
    'Ein Kriterium zu Verantwortung oder Zuständigkeit braucht eine Rolle ({roles}).',
  'accessErrors.criteria.seatHolder':
    'Ein Kriterium zu Verantwortung oder Zuständigkeit braucht eine Liste von Referenzen (values) oder empty: true.',
  'accessErrors.criteria.signalKey':
    'Ein Zustands-Kriterium braucht einen Schlüssel aus dem Katalog.',
  'accessErrors.criteria.fieldKeys':
    'Ein Feld-Kriterium braucht einen moduleKey und einen fieldKey.',
  'accessErrors.criteria.fieldScalar':
    'Ein Feld-Kriterium vergleicht einen einfachen Wert (Text, Zahl, null).',
  'accessErrors.criteria.userTag':
    'Ein Tag kann noch keine Schwelle einer Phase sein. Für einen Zustand gibt es das Zustands-Kriterium.',
  'accessErrors.criteria.ancestor':
    'Eine übergeordnete Aufgabe auf beliebiger Ebene kann noch keine Schwelle einer Phase sein. Eine direkte übergeordnete Aufgabe kann es.',
  'accessErrors.criteria.malformed': 'Unbekanntes oder ungültiges Kriterium.',
  'accessErrors.criteria.predicateNotObject': 'Eine Bedingung muss ein Objekt sein.',
  'accessErrors.criteria.predicateOp': 'Eine Bedingung verknüpft mit all oder any.',
  'accessErrors.criteria.predicateList': 'Eine Bedingung braucht eine Liste von Kriterien.',
} as const satisfies AreaCatalog<typeof en>;
